
import  { useState } from 'react';
import {  CheckCircle } from 'lucide-react';
import EnrollmentPopup from '../../components/EnrollmentPopup';

const COURSE = {
  id: '1',
  title: 'Seller Account Setup Course',
  instructor: 'Manikandan',
  rating: 4.9,
  students: 8450,
  duration: '12h 30m',
  level: 'Beginner',
  price: 'Free',
  category: 'E-Commerce',
  image: 'https://i.pinimg.com/1200x/de/c3/a6/dec3a6cb51913d7876702cb0bc56e14d.jpg',
  description: 'Learn how to register your Amazon, Flipkart & Meesho seller accounts without confusion or rejection. From documents to shipping settings — make your account ready to start selling.',
};

export default function CourseEnroll() {
  const [showPopup, setShowPopup] = useState(false);
const handleEnrollment = (enrollmentData) => {

    console.log('Enrollment Data:', {
      courseId: COURSE?.id,
      courseTitle: COURSE?.title,
      ...enrollmentData
    });
    alert(`Thank you ${enrollmentData?.name}! You have successfully enrolled in ${COURSE?.title}. We will contact you on ${enrollmentData?.whatsappNumber}`);
    setShowPopup(false);
  };

  return (
    <div className=" mt-10 bg-white">
      <div>
        <div className="mb-8">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-black text-slate-900 mb-3 leading-tight">
            {COURSE?.title}
          </h1>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed mb-5">
            {COURSE?.description}
          </p>
          
          <button 
            onClick={() => setShowPopup(true)}
            className=" cursor-pointer w-full sm:w-auto bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold py-3 px-8 rounded-xl  transition-all active:scale-95 hover:-translate-y-0.5 text-sm sm:text-base inline-flex items-center justify-center gap-2"
          >
            <CheckCircle className="w-5 h-5" />
            Confirm Enrollment
          </button>
 </div>
      </div>
      <EnrollmentPopup 
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        courseTitle={COURSE?.title}
        onEnroll={handleEnrollment}
      />
    </div>
  );
}